import { useEffect, useState } from 'react';
import { Line } from "react-chartjs-2";
import { red } from '@mui/material/colors';
import { green } from '@mui/material/colors';
import { alpha } from "@mui/material";
import { chartOptions } from '../../constants/plottingConstants';
import { crosshairGuidesPlugin } from "../../utils/chart"
import ChartContainer from './ChartContainer';


const CustomAreaChart = ({ chartData, chartRef }) => {
    const [chartBorderColor, setChartBorderColor] = useState(red[500])
    const [chartBackgroundColor, setChartBackgroundColor] = useState(red[300])

    useEffect(() => {
        if (chartRef.current) {
            chartRef.current.resetZoom();
        }

        setChartBorderColor(chartData.data.at(-1).y > chartData.data[0].y ? green[500] : red[500])
        setChartBackgroundColor(chartData.data.at(-1).y > chartData.data[0].y ? alpha(green[200], 0.35) : alpha(red[200], 0.35))
    }, [chartData, chartRef]);


    return (
        <ChartContainer>
            <Line
                ref={chartRef}
                style={{ height: 'auto', width: 'auto' }}
                data={{
                    ...chartData,
                    spanGaps: false,
                    datasets: [{
                        ...chartData,
                        fill: true,
                        borderColor: chartBorderColor,
                        backgroundColor: chartBackgroundColor,
                        pointBackgroundColor: chartBackgroundColor,
                    }]
                }}
                options={chartOptions}
                plugins={[crosshairGuidesPlugin]}
            />
        </ChartContainer>
    );
};

export default CustomAreaChart;